// 导入封装好的 axios 实例
import request from '@/utils/request'

// OSS STS 凭证接口
export const ossApi = {
    // 获取 OSS STS 临时凭证
    getSTSToken: () => request.get('/sys/sts/token'),
}

//系统分类列表接口
export function systemList(data) {
    return request({
        url: '/program/system/type/page',
        method: 'post',
        data
    })
}


//新增系统分类
export function addSystemType(data) {
    return request({
        url: '/program/system/type',
        method: 'post',
        data
    })
}

//删除系统分类
export function delsystemtype(id) {
    return request({
        url: `/program/system/type/${id}`,
        method: 'delete',
    })
}

// 传感器分类列表
export function sensorTypeList(data) {
    return request({
        url: '/program/sensor/type/page',
        method: 'post',
        data
    })
}

// 新增或更新传感器分类
export function addOrUpdateSensorType(data) {
    return request({
        url: '/program/sensor/type',
        method: 'post',
        data
    })
}

// 删除传感器分类
export function delSensorType(id) {
    return request({
        url: `/program/sensor/type/${id}`,
        method: 'delete',
    })
}


// 触发规则列表
export function triggerList(data) {
    return request({
        url: '/program/alarm/trigger/page',
        method: 'post',
        data
    })
}

// 新增或更新触发规则
export function addOrUpdateTrigger(data) {
    return request({
        url: '/program/alarm/trigger',
        method: 'post',
        data
    })
}

// 删除触发规则
export function delTrigger(id) {
    return request({
        url: `/program/alarm/trigger/${id}`,
        method: 'delete',
    })
}
